"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyPolicy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="228127" id="privacy-policy" className="relative min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678509/img/minimalist_office_background.png)]" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 z-0 bg-background/90 backdrop-blur-sm" aria-hidden="true" />

      {}
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-screen-xl relative z-10 w-full py-24 md:py-32">
        <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-primary leading-tight mb-8">
            Privacy Policy
          </h1>
          
          <div className="space-y-6 mb-12">
            <p className="font-default text-lg text-foreground/80 leading-relaxed !not-italic md:text-xl">Effective Date: February 1st, 2026&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <br />Your privacy is of paramount importance to us. This policy outlines how we collect, use, and safeguard your personal information to ensure a secure and transparent experience across our digital platforms.</p>
            <p className="font-default text-lg md:text-xl text-foreground/80 leading-relaxed">
              We are committed to maintaining the highest standards of data protection, ensuring that your interactions with our services remain confidential and that your rights as a user are fully respected at every stage of our engagement.
            </p>
          </div>

          <Button asChild size="lg" className="rounded-md px-8 py-6 text-base font-semibold tracking-wide bg-primary text-primary-foreground shadow-md hover:shadow-lg transition-shadow">
            <Link to="/HomePage">
              Return to Home
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}